import request from "@/utils/request";
import { EventSourcePolyfill } from "event-source-polyfill";
import { getToken } from "@/utils/auth";

var baseURL = "http://172.18.20.49:8080";
if (process.env.VUE_APP_BASE_API != "/") {
  // debugger;
  console.log("process.env.VUE_APP_BASE_API:", process.env.VUE_APP_BASE_API);
  baseURL = process.env.VUE_APP_BASE_API;
}

export function postUpload(file) {
  return request({
    url: "/bosc/api/ipcomponents/upload",
    method: "post",
    data: file,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function IpComponentsList() {
  return request({
    url: "/bosc/api/ipcomponents/getIpComponentList",
    method: "get",
  });
}

export function addNewIpInstance(data) {
  // for (var value of data.values()) {
  //   console.log(value)
  // }
  // for (var [a, b] of data.entries()) {
  //   console.log(a, b)
  // }
  return request({
    url: "/bosc/api/ipcomponentsDetails/addItem",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function UpdateJson(JsonData) {
  return request({
    url: "http://172.18.20.2:8892/bosc/api/demo/getAll",
    method: "post",
    data: JSON.stringify(JsonData),
    //data,
    headers: {
      "Content-Type": "application/json;",
    },
  });
}

export function updateIpInstanceInfos(data) {
  return request({
    url: "/bosc/api/ipcomponentsDetails/updateItem",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function edgeAddItem(data) {
  return request({
    headers: {
      "Content-Type": "application/json;",
    },
    url: "/bosc/api/edgeInfos/addItem",
    method: "post",
    data: JSON.stringify(data),
  });
}

export function getEdgeInfosById(edgeId, canvasId) {
  return request({
    url:
      "/bosc/api/edgeInfos/getEdgeInfosById?edgeInstanceId=" +
      edgeId +
      "&canvasId=" +
      canvasId,
    method: "get",
  });
}

export function updateEdge(data) {
  return request({
    headers: {
      "Content-Type": "application/json;",
    },
    url: "/bosc/api/edgeInfos/updateEdge",
    method: "post",
    data: JSON.stringify(data),
  });
}

export function getIpComponentInfos(ipCompId, canvasId) {
  return request({
    url:
      "/bosc/api/ipcomponentsDetails/getIpComponentInfos?ipComponentId=" +
      ipCompId +
      "&canvasId=" +
      canvasId,
    method: "get",
  });
}

export function getAll() {
  return request({
    url: "/bosc/api/soccanvas/getAll",
    method: "get",
  });
}

//data是object
export function get(data) {
  return request({
    url: "/bosc/api/soccanvas/getAll",
    method: "post",
    data,
  });
}

// 获取soc画布名称列表信息
export function getAllSocNames(limit) {
  return request({
    url: "/bosc/api/HomePage/getAllSocCanvas/" + limit,
    method: "get",
  });
}

// 获取soc画布 lib 名称列表信息
export function getAllSocMouduleNames(limit) {
  return request({
    url: "/bosc/api/HomePage/getAllSocModule/" + limit,
    method: "get",
  });
}

// 获取soc画布名称列表信息
export async function getSocNames() {
  return request({
    url: "/bosc/api/socCanvas/getSocByCreateBy",
    method: "get",
  });
}

// 根据名称获取soc画布信息
export function getSocDataByName(name) {
  return request({
    url: `/bosc/api/socCanvas/selectCanvasBySocCanvasId/${name}`,
    method: "get",
    // params: {
    //   socName: name,
    // },
  });
}

// 保存或修改画布信息
export function saveOrUpdateCanvas(data) {
  return request({
    url: "/bosc/api/socCanvas/saveOrupdateCanvas",
    method: "post",
    data,
  });
}

// 保存画布组件
export function saveSocModule(data) {
  return request({
    url: "/bosc/api/socModule/saveSocModule",
    method: "post",
    data,
  });
}

export function updateToVerilogJsonAPI(data) {
  return request({
    url: "/bosc/api/socCanvas/updateToVerilogJsonBySocCanvasId",
    method: "post",
    data,
  });
}

// update soc module
export function updateSocModule(data) {
  return request({
    url: "/bosc/api/socModule/updateSocModule",
    method: "post",
    data,
  });
}

// 根据名称获取soc画布信息
export function getSocModuleByName() {
  return request({
    url: `/bosc/api/socModule/selectSocModuleListByName`,
    method: "get",
  });
}

export function deleteSocProjectById(id) {
  return request({
    url: `/bosc/api/socCanvas/deleteSocCanvas/${id}`,
    method: "get",
  });
}

export function deleteSocModuleBySocModuleld(id) {
  return request({
    url: `/bosc/api/socModule/deleteSocModuleBySocModuleId/${id}`,
    method: "get",
  });
}

// 保存画布组件
// export function jsonToVerilog(data) {
//   return request({
//     url: "/bosc/api/socCanvas/generationCanvas",
//     method: "post",
//     data,
//   });
// }

// get verilog file path
export function getVerilogPathBySocId(data) {
  return request({
    url: "/bosc/api/socCanvas/generationCanvas",
    method: "post",
    data,
  });
}

// get verilog files list by socName
export function getVerilogList(data) {
  return request({
    url: "/bosc/api/socCanvas/getVerilogInfoByPath",
    method: "post",
    data,
  });
}

// get verilog files list by socName
export function updateVerilogFile(data) {
  return request({
    url: "/bosc/api/socCanvas/writeFileByPath",
    method: "post",
    data,
  });
}

// get verilog files list by socName
export function updateVerilogFileName(data) {
  return request({
    url: "/bosc/api/socCanvas/updateVerilogName",
    method: "post",
    data,
  });
}

export function generatelibJsonByVerilogPath(data) {
  return request({
    url: `/bosc/api/socCanvas/libJsonByCore`,
    method: "post",
    params: data,
  });
}

// export function uploadVerilogZip(data) {
//   return request({
//     url: "/bosc/api/socCanvas/libJsonByVerilog",
//     method: "post",
//     data,
//   });
// }

// upload veriolog.zip
export function uploadVerilogZip(data) {
  return request({
    url: "/bosc/api/socCanvas/libJsonByVerilog",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// upload ipxact.zip
export function uploadIpxactZip(file) {
  return request({
    url: "/bosc/api/socCanvas/libJsonByIpxact",
    method: "post",
    data: file,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// upload ipxact.zip
export function getWidthNumber(data) {
  return request({
    url: "/bosc/api/socCanvas/getParameterAndPortWidth",
    method: "post",
    data,
  });
}

export async function getSocTemplate(params) {
  return request({
    url: "/bosc/api/template/getTemplate",
    method: "post",
    params,
  });
}

// exec
export function exec() {
  return request({
    url: "bosc/api/docker/execVerilator",
    method: "get",
  });
}

// exec2
export function exec2() {
  return request({
    url: "bosc/api/docker/execVerilator2",
    method: "get",
  });
}
// getWaveform
export function getWaveform(data) {
  var paramStr = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (paramStr != "") {
      paramStr = paramStr + "&" + key + "=" + value;
    } else {
      paramStr = paramStr + key + "=" + value;
    }
  });

  return request({
    url: `bosc/api/sim/waveform?${paramStr}`,
    method: "get",
  });
}

// get Create Verilator
export function getCreateVerilator(data) {
  // console.log(`process.env.VUE_APP_BASE_API:`,process.env.VUE_APP_BASE_API)
  var paramStr = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (paramStr != "") {
      paramStr = paramStr + "&" + key + "=" + value;
    } else {
      paramStr = paramStr + key + "=" + value;
    }
  });

  process.env.VUE_APP_BASE_API;

  const eventSource = new EventSourcePolyfill(
    `${baseURL}/bosc/api/docker/createVerilator?${paramStr}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
        token: getToken(),
        "Content-Type": "text/event-stream;charset=UTF-8;",
        "Cache-Control": "no-cache",
        Connection: "keep-alive",
        Accept: "text/event-stream",
      },
      heartbeatTimeout: 300000,
      withCredentials: true,
    }
  );
  return eventSource;
}

// get Create Verilator
export function getCreateYosys(data) {
  var paramStr = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (paramStr != "") {
      paramStr = paramStr + "&" + key + "=" + value;
    } else {
      paramStr = paramStr + key + "=" + value;
    }
  });
  const eventSource = new EventSourcePolyfill(
    `${baseURL}/bosc/api/docker/createYosys?${paramStr}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
        token: getToken(),
        "Content-Type": "text/event-stream;charset=UTF-8;",
        "Cache-Control": "no-cache",
        Connection: "keep-alive",
        Accept: "text/event-stream",
      },
      heartbeatTimeout: 300000,
      withCredentials: true,
    }
  );
  return eventSource;
}

// get Create Verilator
export function getCreateOpenSta(data) {
  var paramStr = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (paramStr != "") {
      paramStr = paramStr + "&" + key + "=" + value;
    } else {
      paramStr = paramStr + key + "=" + value;
    }
  });
  const eventSource = new EventSourcePolyfill(
    `${baseURL}/bosc/api/docker/createOpenSta?${paramStr}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
        token: getToken(),
        "Content-Type": "text/event-stream;charset=UTF-8;",
        "Cache-Control": "no-cache",
        Connection: "keep-alive",
        Accept: "text/event-stream",
      },
      heartbeatTimeout: 300000,
      withCredentials: true,
    }
  );
  return eventSource;
}

export function getInfo(token) {
  return request({
    url: "/vue-element-admin/user/info",
    method: "get",
    params: { token },
  });
}

export function del(id) {
  return request({
    url: "/vue-element-admin/user/info?id=" + id,
    method: "delete",
  });
}

export function put(id) {
  return request({
    url: "/vue-element-admin/user/info?id=" + id,
    method: "put",
  });
}

export function logout() {
  return request({
    url: "/vue-element-admin/user/logout",
    method: "post",
  });
}
